import { NavLink, useNavigate } from "react-router-dom";
import { Egg, Bird, ArrowLeft } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function MobileBottomNav() {
  const { t } = useI18n();
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) navigate(-1);
    else navigate("/couples");
  };

  const linkCls = ({ isActive }) =>
    `flex flex-col items-center justify-center gap-0.5 text-xs ${isActive ? "text-olive" : "text-espresso/60"}`;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-t border-app-border h-16 grid grid-cols-3"
      data-testid="mobile-nav"
      data-print-hide
    >
      <NavLink to="/couples" className={linkCls} data-testid="mobile-nav-couples">
        <Egg className="w-5 h-5" /> {t("nav.couples")}
      </NavLink>
      <button
        type="button"
        onClick={goBack}
        className="flex flex-col items-center justify-center gap-0.5 text-xs text-espresso/60 active:text-olive"
        data-testid="mobile-nav-back"
      >
        <span className="w-9 h-9 rounded-full bg-olive text-white flex items-center justify-center shadow-sm">
          <ArrowLeft className="w-5 h-5 rtl:rotate-180" />
        </span>
      </button>
      <NavLink to="/birds" className={linkCls} data-testid="mobile-nav-birds">
        <Bird className="w-5 h-5" /> {t("nav.birds")}
      </NavLink>
    </nav>
  );
}
